import React from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

interface dropbtn {
  name: string;
  id: number;
  setSelectedId: (id :number) => void;
  selected: boolean;
}

const DropButton: React.FC<dropbtn> = (
  {
    name, id, setSelectedId, selected,
  },
) => (
  <div
    className="drop-container"
    onMouseEnter={() => setSelectedId(id)}
  >
    <div
      className={
        `drop-button ${selected ? 'hov' : ''} `
      }
    >
      {name.toUpperCase()}
      <KeyboardArrowDownIcon />
    </div>
  </div>
);

export default DropButton;
